<cfp-login-card [title]="'login.unlock' | translate">
  <cfp-login-loading-spinner [loading]="isLoading()" />

  <cfp-login-messages
    [errorMessages]="errorMessages()"
    [warningMessages]="warningMessages()"
    [successMessages]="successMessages()"
  />

  @if (!isFormSubmitSuccess()) {
    <form [formGroup]="form">
      <cfp-form-group [label]="'login.userNameOrEmail' | translate">
        <cfp-input-text
          [id]="'username'"
          [placeholder]="'login.userNameOrEmail.placeholder' | translate"
          formControlName="username"
          autocomplete="username"
        />
      </cfp-form-group>

      <div class="row">
        <div class="col-12">
          <button id="btn-login" type="submit" class="btn btn-primary pull-right" (click)="send()">
            {{ 'login.unlock' | translate }}
          </button>
          <a class="btn btn-link pull-left px-0" [routerLink]="loginRoute">{{ 'login.cancel' | translate }}</a>
        </div>
      </div>
    </form>
  }
</cfp-login-card>
